import { all, call, fork, takeEvery } from 'redux-saga/effects';
import { changeService } from './actions';
import { CHANGE_SERVICES } from './constants';

function* setService({ payload: { service } }) {
    try {
        yield call(changeService, service);
    } catch (e) {}
}

export function* watchSetService() {
    yield takeEvery(CHANGE_SERVICES, setService);
}

function* userSettingsSaga() {
    yield all([fork(watchSetService)]);
}

export default userSettingsSaga;
